import * as React from 'react';
import classNames from 'classnames';
import * as Classes from '../common/classes';
import { IProps } from '../common/props';
import { RowColWidths } from './utils';

type RowSizeProps = number | string;

export interface IRowProps extends IProps {
  xs?: RowSizeProps;
  sm?: RowSizeProps;
  md?: RowSizeProps;
  lg?: RowSizeProps;
  xl?: RowSizeProps;
  widths?: RowColWidths[];
  form?: boolean;
  noGutters?: boolean;
  onClick?: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}
export type RowProps = IRowProps;

export const Row: React.FC<RowProps> = ({ className, ...props }) => {
  const cls = classNames(Classes.ROW, className, {});

  const { noGutters, /*tag: Tag,*/ form, widths = [], ...attributes } = props;

  const colClasses: string[] = [];

  widths.forEach((colWidth, i) => {
    let colSize = props[colWidth];

    delete attributes[colWidth];

    if (!colSize) {
      return;
    }

    const isXs = !i;
    colClasses.push(
      isXs ? `row-cols-${colSize}` : `row-cols-${colWidth}-${colSize}`
    );
  });

  const classes = classNames(
    cls,
    noGutters ? Classes.GRID_NO_GUTTERS : null,
    form ? 'form-row' : Classes.GRID_ROW,
    colClasses
  );

  return <div {...attributes} className={classes} />;
};
